<template>
  <div>
    <v-row>
      <v-col>
        <h1>Изменения образа жизни</h1>
        <div>
          <h2>Изменение образа жизни подразумевает:</h2>
          <ul>
            <li>Уменьшение  потребления поваренной соли до 5 г/сутки</li>
            <li>Суммарное потребление алкоголя в неделю не должно превышать у мужчин 140 г.(эквивалент ~5 бутылок пива или ~1,5 бутылки вина или ~350 мл водки), у женщин 80 г. (эквивалент ~3 бутылок пива или неполная бутылка вина или ~200 мл водки)</li>
            <li>изменение режима питания  (увеличение потребления растительной пищи, увеличение в рационе калия, кальция (содержатся в овощах, фруктах, зерновых) и магния (содержится в молочных продуктах), а также уменьшение потребления животных жиро; употребление рыбы не реже двух раз в неделю и 300-400 г в сутки овощей и фруктов)</li>
            <li>нормализация массы тела (рекомендуется поддержание массы тела с ИМТ около 25 кг/м2 и окружностью талии менее 102 см у мужчин и менее 88 см у женщин)</li>
            <li>увеличение физической активности (умеренные аэробные нагрузки (ходьба, бег трусцой, езда на велосипеде, плавание, фитнесс) продолжительностью не менее 30 минут в течение 5-7 дней в неделю.)</li>
            <li>отказ от курения</li>
          </ul>
        </div>
        <v-btn color="primary" class="go-back-link"><router-link to="/">Назад</router-link></v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'LifestyleChanging'
}
</script>

<style scoped lang="scss">
  ul {
    li {
      margin-bottom: 10px;
    }
  }
  .go-back-link {
    span {
      a {
        color: white;
        text-decoration: none;
      }
    }
  }
</style>
